import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import RelationsList from "../../taskManagement/taskPane/taskRelationsBox/RelationsList";
import { ActivityRelationsSectionProps, useActivityRelationsSection } from "./ActivityRelationsSection.hooks";

function ActivityRelationsSection(props: ActivityRelationsSectionProps) {
    const { translateString } = useTranslation();
    const { visibleRelations, onAddRelation, onRemoveRelation } = useActivityRelationsSection(props);

    return (
        <>
            <DotLegalHeader headerStyle={"medium"} marginTop={1} marginBottom={0.5} toolTip={translateString("addRelationsTooltip")}>
                {`${translateString("relations")} (${visibleRelations.length})`}
            </DotLegalHeader>
            <RelationsList
                data={visibleRelations}
                onRemoveRelation={props.readOnly ? undefined : onRemoveRelation}
                onRelationAdded={props.readOnly ? undefined : onAddRelation}
            />
        </>
    );
}

export default ActivityRelationsSection;
